import { raise, setup } from 'xstate5';

import {
  checkIfFinishedFetching,
  checkIfHasPendingMutation,
  registerCartMutation,
  registerCartView,
  unregisterPendingCartMutation,
} from './Cart.machine.utils';

import type { CartMachineContext, CartMachineEvent } from './Cart.machine.types';

// ─── MACHINE ────────────────────────────────────────────────────────────────────

export const cartMachine = setup({
  types: {
    context: {} as CartMachineContext,
    events: {} as CartMachineEvent,
  },
  actions: {
    registerCartMutation,
    unregisterPendingCartMutation,
    registerCartView,
  },
  guards: {
    checkIfHasPendingMutation,
    checkIfFinishedFetching,
  },
}).createMachine({
  context: {
    pendingMutations: {
      'add-line-item': 0,
      'edit-line-item': 0,
      'remove-line-item': 0,
    },
    // stores view counts in a hashmap keyed by cartId
    cartViewCounts: {},
  },
  type: 'parallel',
  states: {
    /*
      The state of 'controls' indicates whether cart controls should be disabled.
      It employs data based on the number of pending mutations to disable
      cart controls in order to prevent race conditions and unwanted user actions.
     */
    controls: {
      initial: 'enabled',
      states: {
        enabled: {},
        disabled: {},
      },
    },
  },
  on: {
    //
    // ─────────────────────────────────────────────────────────────────

    REGISTER_PENDING_MUTATION: {
      actions: ['registerCartMutation', raise({ type: 'DISABLE_CART_CONTROLS' })],
    },
    UNREGISTER_PENDING_MUTATION: {
      actions: ['unregisterPendingCartMutation', raise({ type: 'ENABLE_CART_CONTROLS' })],
    },

    // ─────────────────────────────────────────────────────────────────

    ENABLE_CART_CONTROLS: {
      target: '.controls.enabled',
      guard: 'checkIfFinishedFetching',
    },
    DISABLE_CART_CONTROLS: {
      target: '.controls.disabled',
      guard: 'checkIfHasPendingMutation',
    },

    // ─────────────────────────────────────────────────────────────────

    REGISTER_CART_VIEW: {
      actions: ['registerCartView'],
    },
  },
});
